import React from "react"
import { useRouteLoaderData, Form } from "react-router-dom"
import { CurrentOrg } from "../lib/store"
import { getPlanTier, PLAN_TIERS } from "../lib/limits"
import {
  Box,
  Button,
  Input,
  Heading,
  InputGroup,
  InputRightAddon,
  InputLeftAddon,
  Text,
  Tooltip,
} from "@chakra-ui/react"
import { MdManageAccounts } from "react-icons/md"
import IconEdit from "@/icons/IconEdit"
import IconSave from "@/icons/IconSave"
import { getStripeBillingPortalUrl } from "../lib/stripeBilling"

export default function Account() {
  let [editMode, setEditMode] = React.useState("")
  const [currentOrg, setCurrentOrg] = CurrentOrg.useState()
  const user = useRouteLoaderData("auth")

  const isOrgAdmin = React.useMemo(() => {
    if (!currentOrg?.organization_users || !user?.email) return false
    const ownerEmail = currentOrg.owner?.organization_user?.user?.email
    if (user.email === ownerEmail) return true
    const myOrgUser = currentOrg.organization_users.find(
      (ou) => ou.user?.email === user.email,
    )
    return myOrgUser?.is_admin === true
  }, [currentOrg, user])

  return (
    <Box mt="8">
      <Heading size="sm">Organization name</Heading>
      {(editMode === "orgname" && (
        <>
          <Form className="columns">
            <InputGroup variant="standardAddon">
              <InputLeftAddon>Organization name: </InputLeftAddon>
              <Input
                name="orgName"
                placeholder={currentOrg.name}
                value={currentOrg.name}
                onChange={setCurrentOrg.name}
                isRequired
              />
              <InputRightAddon>
                <IconSave
                  as="button"
                  type="submit"
                  color="Primary.500"
                  onClick={() => {
                    setEditMode("")
                  }}
                />
              </InputRightAddon>
            </InputGroup>
          </Form>
        </>
      )) || (
        <Box>
          {currentOrg.name}{" "}
          <IconEdit
            as="Button"
            color="Primary.500"
            onClick={() => {
              setEditMode("orgName")
            }}
          />
        </Box>
      )}
      <Heading size="sm">Subdomain (slug)</Heading>
      {(editMode === "slug" && (
        <>
          <Form>
            <InputGroup variant="standardAddon">
              <InputLeftAddon>Subdomain: </InputLeftAddon>
              <Input
                placeholder={currentOrg.slug}
                value={currentOrg.slug}
                onChange={setCurrentOrg.slug}
                isRequired
              />
              <InputRightAddon>
                <Text>.blindinsight.io</Text>
                <IconSave
                  as="button"
                  type="submit"
                  color="Primary.500"
                  onClick={() => {
                    setEditMode("")
                  }}
                />
              </InputRightAddon>
            </InputGroup>
          </Form>
        </>
      )) || (
        <Text color="black">
          {currentOrg.slug}.blindinsight.io{" "}
          <IconEdit
            as="Button"
            color="Primary.500"
            onClick={() => {
              setEditMode("slug")
            }}
          />
        </Text>
      )}
      <Heading size="sm">Subscription Type</Heading>
      <Text color="black">
        <b>
          {(() => {
            const tier = getPlanTier(currentOrg)
            if (tier === PLAN_TIERS.FREE) return "Free"
            if (tier === PLAN_TIERS.BUILD) return "Build"
            if (tier === PLAN_TIERS.SCALE) return "Scale"
            return tier
          })()}
        </b>{" "}
        <Tooltip label="Ask your org admin" isDisabled={isOrgAdmin} hasArrow>
          <Button
            as={isOrgAdmin ? "a" : "button"}
            href={
              isOrgAdmin ? getStripeBillingPortalUrl(user.email) : undefined
            }
            target={isOrgAdmin ? "_blank" : undefined}
            rel={isOrgAdmin ? "noreferrer" : undefined}
            variant="secondary"
            size="xs"
            rightIcon={<MdManageAccounts />}
            isDisabled={!isOrgAdmin}
            opacity={isOrgAdmin ? 1 : 0.4}
            cursor={isOrgAdmin ? "pointer" : "not-allowed"}
          >
            Manage
          </Button>
        </Tooltip>
      </Text>
    </Box>
  )
}
